import React, { FunctionComponent } from 'react';
import NoData from '../NoData';
import styles from './MostFrequentCard.module.scss';
import Loader from '../Loader';
import { Link } from 'react-router-dom';
import { loadFrequentData } from 'app/Requests';
import DotsMenu from 'app/components/DotsMenu';
import { v4 as uuid } from 'uuid';
import CardTitle from '../CardTitle';
import { useQuery, useQueryClient } from 'react-query';
import ToolTipComp from '../ToolTipComp';
import { checkHoveringTranslated, checkTranslated } from 'app/utils/helpers';
import { handelNameKey } from 'app/utils/handel-name-key';
import { nFormatter } from 'app/utils/numbersFormater';
import { savePrevSearchState } from 'app/utils/search-state';
import ServerError from '../ErrorBoundary/ServerError';
import { useModal } from 'app/context/Modal';
import { _t } from 'app/utils/i18n';
import { ExpandIcon } from 'app/assets/images/icons';
import { Grid } from '@material-ui/core';

interface Props {
  words?: Array<any>;
  compId: string;
  slug?: string;
  expandLink?: any;
  title?: string;
  pageLink?: any;
  expandUrl?: any;
  pageName?: string;
  customFilters?: any;
  hideIfNoData?: boolean;
  withFreqNumber?: any;
  moduleName?: string;
  additionalComponents?: JSX.Element;
  isReport?: boolean;
  hideDots?: boolean;
  withoutPadding?: boolean;
  onItemClickAction?: any;
  noDataMsg?: string;
  testLoading?: boolean;
  grid?: any;
  isTemplate?: boolean;
  loading?: boolean;
  expandAction?: any;
}

const FrequentWordsCard: FunctionComponent<Props> = ({
  words = [],
  compId,
  slug,
  expandLink,
  title,
  pageName,
  pageLink,
  customFilters,
  hideIfNoData,
  expandUrl,
  withFreqNumber,
  moduleName,
  additionalComponents,
  isReport,
  hideDots,
  withoutPadding,
  onItemClickAction,
  noDataMsg,
  testLoading,
  grid,
  isTemplate,
  loading,
  expandAction,
}) => {
  const {
    data: QData,
    isLoading,
    isError,
  } = useQuery(
    ['loadFrequentData', { slug, filters: customFilters }],
    loadFrequentData,
    { enabled: !!slug },
  );
  const queryClient = useQueryClient();
  const modal = useModal();
  const modules: string[] =
    queryClient.getQueryData('getAuthorizedModules') || [];
  const isAuthorized = moduleName ? modules.includes(moduleName) : true;
  const isNotClickable = isTemplate;
  const currentData = !!slug ? QData : words;
  const handelWordContent = (word: {
    name: string;
    hashtag_name?: any;
    word_name?: any;
    original: string;
    name_translated: string;
    arabic: string;
    value: number;
  }) => {
    const content = checkTranslated(
      word?.name ||
        word?.original ||
        word?.hashtag_name?.original ||
        word?.word_name?.original,
      word?.name_translated ||
        word?.arabic ||
        word?.hashtag_name?.arabic ||
        word?.word_name?.arabic,
    );
    return `${content.length > 25 ? `${content.slice(0, 25)}...` : content} ${
      withFreqNumber ? `(${nFormatter(word?.value)})` : ''
    }`;
  };

  if (!(currentData?.length && currentData?.[0]?.length !== 0) && hideIfNoData)
    return <></>;
  loading ? <Loader /> : <></>;
  return (
    <ServerError requiredApiCalls={[isError]}>
      <Grid item {...grid}>
        <div id={compId}>
          <div
            className={styles.FrequentWordsCard}
            id={`${compId}-FrequentWordsCard`}
            data-testid={`${compId}-FrequentWordsCard`}
          >
            {isLoading || testLoading ? (
              <Loader />
            ) : (
              <>
                {title && (
                  <CardTitle
                    title={title}
                    compId={compId}
                    hideIcon={isReport}
                  />
                )}
                <div
                  className={`${styles.FrequentWordsCardHolder} ${
                    withoutPadding ? styles.withoutPadding : ''
                  }`}
                  data-testid="withoutPadding-test-id"
                >
                  <div className={styles.topMenu} data-testid="hideDots-testid">
                    {!isReport && (
                      <div className={styles.Controls}>
                        {(expandUrl || expandAction) && (
                          <div className={styles.ControlsItem}>
                            {expandAction ? (
                              <div onClick={expandAction}>
                                <ExpandIcon />
                              </div>
                            ) : (
                              <Link
                                data-testid="expandUrl"
                                className={styles.ActionBtn}
                                to={expandUrl}
                              >
                                <ExpandIcon />
                              </Link>
                            )}
                          </div>
                        )}
                        {!hideDots && (
                          <DotsMenu id={`${compId}-FrequentWordsCard`} />
                        )}
                      </div>
                    )}
                  </div>

                  <div data-testid="wordsBox-test-id">
                    {currentData?.length && currentData?.[0]?.length !== 0 ? (
                      currentData.map((word: any) => {
                        if (!word) return null;
                        return (
                          <div key={uuid()} className={styles.wordsBox}>
                            {expandLink || pageLink ? (
                              <ToolTipComp
                                title={checkHoveringTranslated(
                                  word?.name ||
                                    word?.name?.original ||
                                    word?.hashtag_name?.original ||
                                    word?.word_name?.original,
                                  word?.name_translated ||
                                    word?.name?.arabic ||
                                    word?.hashtag_name?.original ||
                                    word?.word_name?.original ||
                                    word?.hashtag_name?.arabic(
                                      word?.name?.original?.length ||
                                        word?.name?.length,
                                    ) > 23
                                    ? word?.name?.original ||
                                        word?.name ||
                                        word?.word_name?.original
                                    : '',
                                )}
                              >
                                {isAuthorized && !isNotClickable ? (
                                  <Link
                                    to={
                                      expandLink
                                        ? `${expandLink}/${
                                            word?.id || word?.hashtag_id
                                          }/${savePrevSearchState(
                                            checkTranslated(
                                              word?.name ||
                                                word?.name?.original ||
                                                word?.hashtag_name?.original ||
                                                word?.word_name?.original,
                                              word?.name_translated ||
                                                word?.name?.arabic ||
                                                word?.hashtag_name?.arabic ||
                                                word?.word_name?.arabic,
                                            ),
                                          )}`
                                        : {
                                            pathname: pageLink,
                                            state: {
                                              option: {
                                                label: handelNameKey(
                                                  word.name ||
                                                    word?.word_name?.original ||
                                                    word?.hashtag_name
                                                      ?.original,
                                                ),
                                                value:
                                                  +word.id ||
                                                  word?.hashtag_id ||
                                                  word?.word_id,
                                              },
                                              page: pageName,
                                            },
                                          }
                                    }
                                  >
                                    <p dir="auto">
                                      {checkTranslated(
                                        word?.name ||
                                          word?.name?.original ||
                                          word?.word_name?.original ||
                                          word?.hashtag_name?.original,
                                        word?.name_translated ||
                                          word?.name?.arabic ||
                                          word?.word_name?.arabic ||
                                          word?.hashtag_name?.arabic,
                                      )}
                                    </p>
                                  </Link>
                                ) : isNotClickable ? (
                                  <p dir="auto">
                                    {checkTranslated(
                                      word?.name ||
                                        word?.name?.original ||
                                        word?.word_name?.original ||
                                        word?.hashtag_name?.original,
                                      word?.name_translated ||
                                        word?.name?.arabic ||
                                        word?.word_name?.arabic ||
                                        word?.hashtag_name?.arabic,
                                    )}
                                  </p>
                                ) : (
                                  <p
                                    className="cursor-pointer"
                                    dir="auto"
                                    onClick={() => {
                                      modal.show({
                                        isAlternative: true,
                                        message: _t(
                                          `basic:you_are_not_authorize`,
                                        ),
                                      });
                                    }}
                                  >
                                    {checkTranslated(
                                      word?.name || word?.name?.original,
                                      word?.name_translated ||
                                        word?.name?.arabic,
                                    )}
                                  </p>
                                )}
                              </ToolTipComp>
                            ) : typeof word === 'object' ? (
                              <ToolTipComp
                                title={checkHoveringTranslated(
                                  word?.name || word?.original,
                                  word?.name_translated ||
                                    word?.arabic ||
                                    (word?.original?.length || word?.length) >
                                      23
                                    ? word?.original || word?.name
                                    : '',
                                )}
                              >
                                <p
                                  dir="auto"
                                  className={
                                    onItemClickAction ? 'cursor-pointer' : ''
                                  }
                                  onClick={
                                    onItemClickAction
                                      ? () => onItemClickAction?.(word)
                                      : undefined
                                  }
                                  data-testid="onItemClickAction-test-id"
                                >
                                  {handelWordContent(word)}
                                </p>
                              </ToolTipComp>
                            ) : (
                              <ToolTipComp
                                title={checkHoveringTranslated(
                                  word?.name,
                                  word?.name_translated,
                                )}
                              >
                                <p dir="auto">
                                  {checkTranslated(
                                    word.name,
                                    word.name_translated,
                                  )}
                                </p>
                              </ToolTipComp>
                            )}
                          </div>
                        );
                      })
                    ) : (
                      <NoData noDataMsg={noDataMsg} />
                    )}
                  </div>
                </div>
              </>
            )}
            {additionalComponents}
          </div>
        </div>
      </Grid>
    </ServerError>
  );
};

export default FrequentWordsCard;
